import { Link, useHistory } from "react-router-dom";
import { useState } from "react";
import { linkHelper } from "../../helper/LinkHelper";
import { MAILING_URL } from "../../constants/APIEndpointConstants";
import "../../assets/css/header.css";
import $ from "jquery";
const Header = ({ data }) => {
  const history = useHistory();
  const { header_tag_line, items, logo, logo_text } =
    data?.header?.["top-header-menu"]?.menu;
  global.join_mailing_list =
    data?.header?.["top-header-menu"]?.menu?.subscription_heading_text;
  const [search, setSearch] = useState("");
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    search !== ""
      ? history.push(`/search?s=${search}`)
      : alert("Please enter the search term");
  };
  const handleToggle = () => {
    $(document).on("click", ".navbar-collapse.in", function (e) {
      if ($(e.target).is("a")) {
        $(this).collapse("hide");
      }
    });
  };
  return (
    <div className="container">
      <div className="row hidden-xs">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header">
          <div className="pull-left">{header_tag_line}</div>
          <span className="pull-right">
            <a href={MAILING_URL}>{global?.join_mailing_list}</a>
          </span>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 menu_container">
          <nav className="navbar navbar-default menu-whole">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#polity_nav"
                aria-expanded="false"
              >
                <span className="sr-only">Toggle navigation</span>
                <div className="pull-left mobile_menu">MENU</div>
                <span className="glyphicon glyphicon-menu-up menu_arrow"></span>
              </button>
              <div className="nav_brand_img">
                <Link to="/" className="nav_brand_img">
                  <img
                    src={logo}
                    alt={logo_text}
                    title={logo_text}
                    className="img-responsive logo-polity"
                  />
                </Link>
              </div>
            </div>
            <div className="collapse navbar-collapse menu-out" id="polity_nav">
              <ul className="nav navbar-nav menu-in">
                {items?.map((item) => (
                  <li key={item.ID} onClick={handleToggle}>
                    {linkHelper(item)}
                  </li>
                ))}
              </ul>

              <form
                className="navbar-form navbar-right top_search"
                onSubmit={handleSearchSubmit}
              >
                <div className="form-group">
                  <div className="input-group search_box">
                    <span className="input-group-btn">
                      <button className="btn btn-default" type="submit">
                        <i className="glyphicon glyphicon-search search_icon"></i>
                      </button>
                    </span>
                    <input
                      type="text"
                      name="s"
                      className="form-control"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="col-xs-12 no-padding-margin hidden-sm hidden-md hidden-lg pull-left">
                    {header_tag_line}
                  </div>
                  <span className="col-xs-12 no-padding-margin hidden-sm hidden-md hidden-lg pull-left">
                    <a href={MAILING_URL}>{global?.join_mailing_list}</a>
                  </span>
                </div>
              </form>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Header;
